export default __webpack_public_path__ + "static/media/projectRes6.6bd01ea9.jpg";